<su-headline h="h1" skin="primary">{{ headline }}</su-headline>

<form [formGroup]="form">
  <div class="field-container">
    <mat-form-field appearance="fill">
      <mat-label>{{
        'taskmodule.shared.label__incidentType' | translate
      }}</mat-label>

      <mat-select formControlName="selectedTicketType">
        <mat-option *ngFor="let type of ticketTypes$ | async" [value]="type">
          {{ type }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{
        'taskmodule.shared.label__incidentClass' | translate
      }}</mat-label>
      <mat-select formControlName="selectedTicketClass">
        <mat-option
          *ngFor="let class of ticketClasses$ | async"
          [value]="class.id">
          {{ class.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{
        'taskmodule.shared.label__subject' | translate
      }}</mat-label>
      <mat-select formControlName="selectedTask">
        <mat-option [value]="'documents.label__noTask' | translate">{{
          'documents.label__noTask' | translate
        }}</mat-option>
        <mat-option *ngFor="let task of tasks$ | async" [value]="task.id">
          {{ task.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>

<div style="display: flex; gap: 20px">
  <su-button
    skin="primary"
    [label]="'shared.add' | translate"
    [disabled]="!classControl.value"
    (onClick)="getDocumentTypesSelection()"></su-button>

  <su-button
    skin="secondary"
    [label]="'edit_document_types.label__assume_for_all' | translate"
    [disabled]="!((dataChange$ | async)?.length > 0 && isTaskSelected)"
    (onClick)="assumeForAllTasks()"></su-button>
</div>

<app-data-table
  [columns]="columns"
  [config]="config"
  [data]="dataChange$ | async"></app-data-table>

<ng-template #checkboxTemplate let-row>
  <mat-checkbox
    [disabled]="
      (checkIfDefaultExists(data$.value, row) && !row.default) ||
      !isTaskSelected
    "
    [(ngModel)]="row.default"
    (ngModelChange)="onDefaultChange(row)"></mat-checkbox>
</ng-template>

<ng-template #deleteTemplate let-row>
  <su-button
    skin="secondary"
    icon="x"
    (onClick)="onDeleteDocumentType(row)"></su-button>
</ng-template>

<app-spinner-overlay
  [show]="loading"
  [label]="loadingMessage"></app-spinner-overlay>
